import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { FAVORITES_QUERY } from 'apollo'

export const useFavoritesQuery = (options: QueryHookOptions<any, any> = {}) => useQuery(FAVORITES_QUERY, options)
